export default "__VITE_ASSET__CDrbKLOp__"